/* eslint-disable prettier/prettier */
import Colors from '@constants/Colors';
import TipIcon from "@icons/AddCircle";
import VoidIcon from "@icons/CloseCircle";
import DiscountIcon from "@icons/MinusCircle";

export const CHECK_TYPE = {
  DISCOUNT: "1",
  VOID: "2",
  TIP: "3",
};

const CHECK_DESCRIPTION: CheckDescriptionType = {
  "1": (checkNo: string) => `Discount for check #${checkNo} greater than 25%`,
  "2": (checkNo: string) => `Void item in check #${checkNo}`,
  "3": (checkNo: string) => `Tip for check #${checkNo} greater than 25%`,
};

export const CHECK_TYPE_COLOR: CheckTitleType = {
  "1": Colors.info_600,
  "2": Colors.secondaryorange_500,
  "3": Colors.success_600,
};

export const getDescription = ({ type, checkNo }: DescriptionType) => {
  return CHECK_DESCRIPTION[type]?.(checkNo);
};

export const getCheckIcon = (type: string) => {
  switch (type) {
  case CHECK_TYPE.DISCOUNT:
    return <DiscountIcon color={CHECK_TYPE_COLOR[type]} width="16" height="16" />;
  case CHECK_TYPE.TIP:
    return <TipIcon color={CHECK_TYPE_COLOR[type]} width="16" height="16" />;
  case CHECK_TYPE.VOID:
    return <VoidIcon color={CHECK_TYPE_COLOR[type]} width="16" height="16" />;
  default:
    return <DiscountIcon color={CHECK_TYPE_COLOR[type]} width="16" height="16" />;
  }
};

export const CHECK_TITLE: CheckTitleType = {
  "1": "Discount",
  "2": "Void",
  "3": "Tip",
};

export const CHECK_TITLE_SUMMARY: CheckTitleType = {
  "1": "Discounts",
  "2": "Voids",
  "3": "Tips",
};
